<h3 mat-dialog-title class="title">{{ data.title }}</h3>

<mat-dialog-content>
    <div class="messages">
        <txp-message [type]="messageType.DANGER"
                     data-qa-label="ErrorMessage"
                     *ngIf="showError">
            {{ errorMessage}}
        </txp-message>
    </div>

    <div class="content" [innerHTML]="data.message"></div>
    <!-- Add data.checkbox = true and checkboxLabel in data objet to have a check box in the dialog -->
    <div *ngIf="data.checkbox"
            class="acknowledge-input">
        <mat-checkbox
        data-qa-label="ConfirmCheckbox"
        [disabled]="isSaving"
        (change) = "disableContinueBtn = !$event.checked">
        {{data.checkboxLabel}}
        </mat-checkbox>
    </div>
    <!-- Add data.toggle = {status: boolean, label: string} in data objet to have a slide toggle in the dialog -->
    <div *ngIf="data.toggle" class="acknowledge-input">
        <mat-slide-toggle data-qa-label="Toggle"
                      [checked]="data.toggle.status"
                      [disabled]="isSaving"
                      (change)="data.toggle.status = $event.checked">
            {{data.toggle.label}}
        </mat-slide-toggle>
    </div>

    <div *ngIf="data.urlLinks" class="url-links">
        <ng-container  *ngFor="let link of data.urlLinks">
            <a [href]="link.url"
               target="_blank"
               rel="noopener noreferrer"
               class="edit-link">{{link.label}}{{link.url}}</a>
        </ng-container>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <txp-button (click)="onAction(false)"
        [hidden]="!data.cancelText"
        data-qa-label="CancelButton"
        [style]="buttonStyle.SECONDARY"
        [disabled]="isSaving">
        {{ data.cancelText }}
    </txp-button>
    <txp-button data-qa-label="ContinueButton"
        [style]="buttonStyle.PRIMARY"
        (click)="onAction(true)"
        [loading]="isSaving"
        [disabled]="disableContinueBtn" >
        {{ data.confirmText }}
    </txp-button>
</mat-dialog-actions>
